import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SPAButton from '../shared/SPAButton';
import SPADropdown from '../shared/SPADropdown';
import { useContentMount } from './contentMount';
import { programNewPath } from './ProgramEdit/editSections';

// AIDEV-NOTE: "Add Program" is a dropdown with two paths:
//   - "Create new" is a router link to the New Program page (routed on both mounts)
//   - "Reuse existing" navigates to the reuse-program routed modal, relative to the Programs page
//     route so it resolves under both program tabs and both mounts.
const AddProgramMenu = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const newPath = programNewPath(useContentMount());

  return (
    <SPADropdown open={open} onOpenChange={setOpen}>
      <SPADropdown.Trigger asChild>
        <SPAButton size="md" variant="primary">
          Add Program
          <svg className="tw-w-3.5 tw-h-3.5 tw-fill-current tw-opacity-75" viewBox="0 0 12 12">
            <path d="M2 4l4 4 4-4" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
          </svg>
        </SPAButton>
      </SPADropdown.Trigger>
      <SPADropdown.Content className="tw-w-52">
        <SPADropdown.Item asChild>
          <Link to={newPath}>Create new program</Link>
        </SPADropdown.Item>
        {/* Radix closes the menu itself after onSelect. */}
        <SPADropdown.Item onSelect={() => navigate('reuse-program')}>
          Reuse existing program
        </SPADropdown.Item>
      </SPADropdown.Content>
    </SPADropdown>
  );
};

export default AddProgramMenu;
